/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useImperativeHandle } from 'react';
import { useDispatch, useSelector } from "react-redux";
import usePrevious from "../../../../Shared/components/Previous";
import productActions from "../../../Product/redux/actions";
import crudActions from "../../../../CRUD/redux/actions";
import { QuantityCustomTable, QuantityCustomForm, QuantityTopBar } from "./Quantity";
import moment from 'moment';
import { ImportExport } from '../../../../Shared/components/ImportExport';
import { toast } from 'react-toastify';
import DeleteModal from "../../../../Shared/components/DeleteModal";
import actions from "../../redux/actions";
import { emptyValidation } from "../../../../../helpers/validation";
import { checkViewPermission } from '../../../../../helpers/utilities';
import unitActions from "../../redux/actions";
import { useEventListener } from "../../../../../helpers/useEventListener";
import { getRequest } from '../../../../../helpers/axiosClient';

const QuantityDiscount = React.forwardRef((props, ref) => {
    const { createDetails, createError, editDetails, editError, createData } = useSelector(state => state.crudReducer);
    const { maintainPriceDetails, maintainPriceLoader } = useSelector(state => state.productSetupReducer);
    const { parameterDetails } = useSelector(state => state.homeReducer);
    const { heads, title, topBarView, customerId, groupId, roleManagement, history } = props;
    const { unitMesurementdetails } = useSelector(state => state.productSetupReducer);
    const [loadMore, setLoadMore] = useState(false);
    const [loadMoreContent, setLoadMoreContent] = useState(false);
    const { getList, getData } = useSelector(state => state.crudReducer);
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("id");
    const [skip, setSkip] = useState(0);
    const limit = 25;
    const [error, setError] = useState({});
    const [commonError, setCommonError] = useState(false);
    const [form, setForm] = useState({});
    const [priceId, setPriceId] = useState('');
    const [dateValue] = useState([null, null]);
    const [deleteModal, setDeleteModal] = useState(false);
    const [importVisible, setImportVisible] = useState(false);
    const dispatch = useDispatch();
    const [view, setView] = useState(false);
    const [visible, setVisible] = useState(false);
    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);
    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);
    const [units, setUnits] = useState([]);
    const [freeUnits, setFreeUnits] = useState([]);
    const [topBar, setTopBar] = useState({
        type: 'ALL',
        status: "active"
    });

    const [freeProducts, setFreeProducts] = useState([]);


    const handleKeyDown = (e) => {
        if (topBarView && e.altKey && e.keyCode === 78) {
            e.preventDefault();
            handleEmpty(true);
        } else if (topBarView && e.altKey && e.keyCode === 83) {
            e.preventDefault();
            if (visible) {
                handleSubmit(e);
            }
        } else if (topBarView && e.altKey && e.keyCode === 69) {
            e.preventDefault();
            if (visible && view) {
                onEdit(form);
            }
        }
    }

    useEventListener("keydown", handleKeyDown);

    useEffect(() => {
        if (roleManagement !== '') {
            if (checkViewPermission('Sales Quantity Discount', history, 'Sales')) {
                dispatch({
                    type: unitActions.UNITMESUREMENT_DETAILS_START, url: 'unit', filter: {
                        order: 'id desc'
                    }
                });
            }
        }
        return () => {
            dispatch({ type: productActions.CLEAR_PRICE_START });
        };
    }, [roleManagement]);


    useEffect(() => {
        if (roleManagement !== '') {
            if (checkViewPermission('Sales Quantity Discount', history, 'Sales')) {
                dispatchFilter(dateValue, sortBy, sortOrder);
            }
        }
    }, [topBar, roleManagement]);

    useEffect(() => {
        setForm({
            'priceSpec': 'SALES QUANTITY DISCOUNT',
            'quantitySpec': 'SAME ITEM',
            'customerSpec': 'ALL',
            'isActive': true
        });
    }, [title]);

    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFilter(dateValue, sortBy, sortOrder);
    }

    const dispatchFilter = (dateValue, sortBy, sortOrder, skip = 0, productId = '') => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }

        let filter = { "and": [] };
        let or = { "or": [] }
        if (topBar?.startDate && topBar?.endDate) {
            filter['and'].push({ fromDate: { gte: moment(topBar?.startDate).format('YYYY-MM-DD') } });
            filter['and'].push({ toDate: { lte: moment(topBar?.endDate).format('YYYY-MM-DD') } });
        }

        if (topBar?.status) {
            filter['and'].push({ isActive: topBar?.status === 'active' ? true : false });
        }

        if (topBar?.customerId || customerId) {
            //let cusOr = { "or": [] }
            if (customerId) {
                if (groupId) {
                    or['or'].push({ customerGroupId: groupId });
                }
                or['or'].push({ customerId: customerId });
            } else {
                filter['and'].push({ customerId: topBar?.customerId });
            }
        }


        if (topBar?.type && topBar?.type !== 'ALL') {
            filter['and'].push({ customerSpec: topBar?.type });
        }

        if (topBar?.customerGroupId !== '') {
            filter['and'].push({ customerGroupId: topBar?.customerGroupId });
        }

        if (topBar?.search && topBar?.search !== '') {
            or['or'].push({ priceSpec: { like: '%' + topBar?.search.trim() + '%' } });
            or['or'].push({ customerSpec: { like: '%' + topBar?.search.trim() + '%' } });
        }

        if (topBar?.saleItemId !== '') {
            filter['and'].push({ saleItemId: topBar?.saleItemId });
        }

        filter['and'].push(or);
        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'sales-quantities',
            skip: skip,
            filter: {
                where: filter,
                order: sortBy + ' ' + sortOrder,
                limit: limit,
                skip: skip
            },
        });
    }

    const loadImportExportData = (name, data = 'existing', selected = [], extension = 'xlsx', exportType = 'export') => {
        let filter = { "and": [] };
        let or = { "or": [] };

        if (topBar?.startDate && topBar?.endDate) {
            filter['and'].push({ fromDate: { gte: moment(topBar?.startDate).format('YYYY-MM-DD') } });
            filter['and'].push({ toDate: { lte: moment(topBar?.endDate).format('YYYY-MM-DD') } });
        }

        if (topBar?.status) {
            filter['and'].push({ isActive: topBar?.status === 'active' ? true : false });
        }

        if (topBar?.customerId || customerId) {
            //let cusOr = { "or": [] }
            if (customerId) {
                if (groupId) {
                    or['or'].push({ customerGroupId: groupId });
                }
                or['or'].push({ customerId: customerId });
            } else {
                filter['and'].push({ customerId: topBar?.customerId });
            }
        }

        if (topBar?.type && topBar?.type !== 'ALL') {
            filter['and'].push({ customerSpec: topBar?.type });
        }

        if (topBar?.customerGroupId !== '') {
            filter['and'].push({ customerGroupId: topBar?.customerGroupId });
        }

        if (topBar?.search && topBar?.search !== '') {
            or['or'].push({ priceSpec: { like: '%' + topBar?.search.trim() + '%' } });
            or['or'].push({ customerSpec: { like: '%' + topBar?.search.trim() + '%' } });
        }

        if (topBar?.saleItemId !== '') {
            filter['and'].push({ saleItemId: topBar?.saleItemId });
        }

        filter['and'].push(or);
        dispatch({
            type: actions.MAINTAIN_PRICE_DETAILS_START,
            export: name,
            data: data,
            selected: selected,
            extension: extension,
            exportType: exportType,
            url: 'sales-quantities',
            filter: {
                where: filter,
                order: sortBy + ' ' + sortOrder,
            }
        });
    }

    const prevGetData = usePrevious(getData);
    useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData.length > 0) {
                    setLoadMore(true);
                    if (getData.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);


    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(dateValue, sortBy, sortOrder, s);
    }

    const handleUnits = (data, type = 'product') => {
        let filter = {
            where: {
                and: [{ productId: data?.id }, { or: [{ unitId: data?.salesUnitId }, { toUnitId: data?.salesUnitId },] }]
            }
        }; let uFilter = {
            where: {
                or: [{ unitId: data?.salesUnitId }, { toUnitId: data?.salesUnitId }]
            }
        };
        let a = [data?.salesUnitId, data?.skuUnitId];

        getRequest(`${process.env.REACT_APP_API_URL}/product-unit-conversions/?filter=${encodeURIComponent(JSON.stringify(filter))}`)
            .then(response => {
                let data = response.data;
                if (data && data.length > 0) {
                    data.forEach(el => {
                        a.push(el.unitId)
                        a.push(el.toUnitId);
                    });
                }
                return getRequest(`${process.env.REACT_APP_API_URL}/unit-conversions/?filter=${encodeURIComponent(JSON.stringify(uFilter))}`);
            }).then(uResponse => {
                let uData = uResponse.data;
                if (uData && uData.length > 0) {
                    uData.forEach(el => {
                        a.push(el.unitId)
                        a.push(el.toUnitId)
                    });
                }
                const filtered = unitMesurementdetails.filter(el => a.includes(el.id));
                if (type === 'product') {
                    setUnits(parameterDetails?.inventoryTransaction ? filtered : unitMesurementdetails);
                } else {
                    setFreeUnits(parameterDetails?.inventoryTransaction ? filtered : unitMesurementdetails);
                }
            })
            .catch(error => {
                console.error("Error fetching data", error);
            });
    }

    const productApi = (search = '', id = '') => {
        let filter = { ["and"]: [{ status: 'ACTIVE' }, { ["or"]: [{ transType: { eq: null } }, { transType: { eq: 'SALES' } }] }] };
        let or = { ["or"]: [] };

        if (search !== undefined && search !== null && search !== '') {
            or['or'].push({ productName: { like: '%' + search.trim() + '%' } });
            or['or'].push({ description: { like: '%' + search.trim() + '%' } });
            or['or'].push({ productId: { like: '%' + search.trim() + '%' } });
            or['or'].push({ barcode: { like: '%' + search.trim() + '%' } });
            or['or'].push({ code: { like: '%' + search.trim() + '%' } });
        }

        if (id !== undefined && id !== null && id !== '') {
            or['or'].push({ id: id });
        }
        if (or.or.length > 0) {
            filter['and'].push(or);
        }
        dispatch({
            type: productActions.MYPRODUCT_DETAILS_START, url: 'client-products',
            filter: {
                where: filter,
                order: 'id desc',
                limit: 50,
                skip: 0
            },
        });
    }

    const productFreeApi = (search = '', id = '') => {
        let filter = { ["and"]: [{ status: 'ACTIVE' }, { ["or"]: [{ transType: { eq: null } }, { transType: { eq: 'SALES' } }] }] };
        let or = { ["or"]: [] };

        if (search !== undefined && search !== null && search !== '') {
            or['or'].push({ productName: { like: '%' + search.trim() + '%' } });
            or['or'].push({ productId: { like: '%' + search.trim() + '%' } });
            or['or'].push({ barcode: { like: '%' + search.trim() + '%' } });
            or['or'].push({ code: { like: '%' + search.trim() + '%' } });
        }

        if (id !== undefined && id !== null && id !== '') {
            or['or'].push({ id: id });
        }
        if (or.or.length > 0) {
            filter['and'].push(or);
        }
        filter = { where: filter, order: 'id desc' }
        getRequest(`${process.env.REACT_APP_API_URL}/client-products/?filter=${encodeURIComponent(JSON.stringify(filter))}`)
            .then(uResponse => {
                setFreeProducts(uResponse?.data || []);
            })
            .catch(error => {
                console.error("Error fetching data", error);
            });
    }

    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            if (createData?.error?.message) {
                setCommonError(createData?.error?.message);
            } else {
                toast.dismiss();
                toast(createDetails);
                handleEmpty(false); dispatchFilter(dateValue, sortBy, sortOrder);
            }
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            let message = createError.error.message;
            setCommonError(message);
        }
    }, [createDetails, createError]);

    useEffect(() => {
        if (!customerId && prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            toast.dismiss();
            toast(editDetails);
            handleEmpty(false); dispatchFilter(dateValue, sortBy, sortOrder);
        } else if (!customerId && prevEditError !== undefined && editError && prevEditError !== editError) {
            let message = editError?.error?.message;
            setCommonError(message);
        }
    }, [editDetails, editError]);

    useImperativeHandle(ref, () => ({
        dispatchFilter(productId) {
            dispatchFilter(dateValue, sortBy, sortOrder, skip, productId)
        }
    }));

    const handleEmpty = (d) => {
        setVisible(d);
        setError({});
        setView(false);
        setForm({
            'priceSpec': 'SALES QUANTITY DISCOUNT',
            'priceId': "blank",
            'quantitySpec': 'SAME ITEM',
            'customerSpec': 'ALL', 'isActive': true
        });
        productApi(); productFreeApi();
        setCommonError(false);
        setPriceId('');
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        let emptyProductId = emptyValidation('Product', form?.saleItemId);
        let emptyUnitId = emptyValidation('Unit', form?.salesUnitId);
        let emptyQuantity = emptyValidation('Quantity', form?.salesQty);
        let emptyFreeProductId = emptyValidation('Free Product', form?.freeItemId);
        let emptyFreeQuantity = emptyValidation('Free Quantity', form?.freeQty);
        let emptyFreeUnitId = emptyValidation('Free Unit', form?.freeUnitId);
        let emptyCustomerId = { isValid: true, errors: '' };
        let emptyCustomerGroupId = { isValid: true, errors: '' };
        let date = true;
        let fromDate = moment(form?.fromDate).format("YYYY-MM-DD");
        let toDate = moment(form?.toDate).format("YYYY-MM-DD");
        if (form?.fromDate && form?.toDate) {
            if (moment(toDate).diff(moment(fromDate), 'days') < 0) {
                date = false;
            }
        }

        let quantitySpec = { isValid: true, errors: '' };
        console.log(form);
        if (form?.quantitySpec === 'SAME ITEM') {
            if (form?.saleItemId !== form?.freeItemId) {
                quantitySpec = { isValid: false, errors: 'Please verify, as the Sales Item product and the Free Product appear to be different.' };
            }
        }

        if (form?.customerSpec === 'SPECIFIC') {
            emptyCustomerId = emptyValidation('Customer', form?.customerId, 'dropDown');
        } else if (form?.customerSpec === 'GROUP') {
            emptyCustomerGroupId = emptyValidation('Customer Group', form?.customerGroupId, 'dropDown');
        }
        setError({});
        if (emptyProductId.isValid && emptyUnitId.isValid && quantitySpec.isValid && emptyQuantity.isValid && emptyFreeProductId.isValid
            && emptyFreeQuantity.isValid && emptyFreeUnitId.isValid && emptyCustomerId.isValid && emptyCustomerGroupId.isValid
        ) {
            delete form.id;
            delete form.salesUnit;
            delete form.saleItem; delete form.freeItem; delete form.freeUnit;
            delete form.customer;
            delete form.customerGroup;

            let data = Object.fromEntries(Object.entries(form).filter(([_, v]) => v !== null && v !== ''));

            if (data?.fromDate) {
                data.fromDate = moment(data?.fromDate).format("YYYY-MM-DD")
            }

            if (data?.toDate) {
                data.toDate = moment(data?.toDate).format("YYYY-MM-DD")
            }

            if (data?.salesQty) {
                data.salesQty = parseFloat(data.salesQty);
            }
            if (data?.freeQty) {
                data.freeQty = parseFloat(data.freeQty);
            }
            dispatch({
                type: priceId === '' ? crudActions.CREATE_DETAILS_START : crudActions.EDIT_DETAILS_START,
                //type: form?.id ? crudActions.EDIT_DETAILS_START : crudActions.CREATE_DETAILS_START,
                url: "sales-quantities",
                title: "Sales Quantity Discount",
                method: "put",
                id: priceId,
                details: data
            })
        } else {
            setError({
                'saleItemId': emptyProductId.errors || false,
                'salesUnitId': emptyUnitId.errors || false,
                'salesQty': emptyQuantity?.errors || false,
                'freeItemId': emptyFreeProductId?.errors || quantitySpec?.errors || false,
                'freeUnitId': emptyFreeUnitId.errors || false,
                'freeQty': emptyFreeQuantity.errors || false,
                'customerId': emptyCustomerId.errors || false,
                'customerGroupId': emptyCustomerGroupId.errors || false,
                'toDate': date ? '' : 'To date is not lesser than from date'
            })
        }
    }

    const onEdit = (data, view = false) => {
        setView(view);
        setPriceId(data?.id);
        setForm({ ...data });
        setVisible(true);
        handleUnits(data?.saleItem, 'product');
        handleUnits(data?.freeItem, 'freeProduct');
        productApi('', data?.saleItemId); productFreeApi('', data?.freeItemId);
    }


    const handleDeactive = (data) => {
        dispatch({
            type: crudActions.EDIT_DETAILS_START,
            url: "sales-quantities",
            title: "Quantity Discount",
            id: data?.id,
            details: {
                'isActive': !data?.isActive
            }
        })
    }

    const onDelete = (data) => {
        setPriceId(data?.id);
        setForm({ ...data });
        setDeleteModal(true);
    }

    const changeHandler = (e, name = '') => {
        if (name !== '') {
            setForm({
                ...form,
                [name]: e,
            });
        } else {
            setForm({
                ...form,
                [e.target.name]: e.target.value,
            });
        }
    }

    const handleFreeProductChange = (data) => {
        setForm({
            ...form,
            'freeItemId': data?.id,
            'freeUnitId': data?.salesUnitId || ''
        });
        handleUnits(data, 'productFree');
        setError({});
    }


    const handleProductChange = (data) => {
        setForm({
            ...form,
            'saleItemId': data?.id,
            'salesUnitId': data?.salesUnitId || ''
        });
        console.log(data);
        handleUnits(data, 'product');
        setError({});
    }

    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    const changeTopHandler = (value, name) => {
        if (name === 'type' && (value === 'ALL' || value === 'SPECIFIC' || value === 'GROUP')) {
            setTopBar({
                ...topBar,
                [name]: value,
                customerId: '',
                customerGroupId: '',
                customerSpec: value !== 'ALL' ? value : ''
            })
        } else if (name === 'dateFilter') {
            setTopBar({
                ...topBar,
                'startDate': '', 'endDate': '',
            })
        } else {
            setTopBar({
                ...topBar,
                [name]: value
            })
        }
    }

    return (
        <React.Fragment>
            <QuantityTopBar
                handleCreate={() => handleEmpty(true)}
                topBarView={topBarView}
                onImportVisible={(v) => setImportVisible(v)}
                roleManagement={roleManagement}
                topBar={topBar}
                title={title}
                loadImportExportData={(name) => loadImportExportData(name)}
                changeHandler={(value, name) => changeTopHandler(value, name)}
                productApi={(s = '', id = '') => productApi(s, id)}
            />
            <QuantityCustomTable
                heads={heads}
                topBar={topBar}
                roleManagement={roleManagement}
                handleDeactive={(data) => { handleDeactive(data) }}
                sortOrder={sortOrder}
                loadMore={loadMore}
                loadMoreContent={loadMoreContent}
                loadMoreTask={() => loadMoreTask()}
                details={customerId ? getList && getList?.filter((item) => {
                    return item.fromDate > moment().format('YYYY-MM-DD') || item.toDate > moment().format('YYYY-MM-DD') || item.toDate === null || item.fromDate === null;
                }) : getList}
                sortBy={sortBy}
                dateValue={dateValue}
                type={customerId ? 'singleCustomer' : topBar?.type}
                {...props}
                onEdit={(data) => onEdit(data)}
                onView={(data) => onEdit(data, true)}
                onDelete={(data) => onDelete(data)}
                handleCreate={() => handleEmpty(true)}
                onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)}
            />
            <QuantityCustomForm
                customerId={customerId}
                roleManagement={roleManagement}
                changeHandler={(e, fieldName) => changeHandler(e, fieldName)}
                handleProductChange={(data) => handleProductChange(data)}
                handleFreeProductChange={(data) => handleFreeProductChange(data)}
                handleIsActive={(data) => setForm({ ...form, "isActive": data })}
                form={{ ...form }}
                title={title}
                view={view}
                priceId={priceId}
                error={{ ...error }}
                units={units}
                freeUnits={freeUnits}
                customObject={(details, id) => customObject(details, id)}
                commonError={commonError}
                handleSubmit={(e) => handleSubmit(e)}
                handleClose={() => handleEmpty(false)} visible={visible}
                handleEdit={(d) => setView(d)}
                freeProducts={freeProducts}
                productApi={(s = '', id = '') => productApi(s, id)}
                productFreeApi={(s = '', id = '') => productFreeApi(s, id)}
            />
            <DeleteModal onClose={(v) => setDeleteModal(v)} id={priceId} loadTasks={() => dispatchFilter(dateValue, sortBy, sortOrder)}
                name={form?.salesPriceId} url={'sales-quantities'}
                title={'Sales Quantity Discount'} visible={deleteModal}
            />
            <ImportExport
                handleClose={() => setImportVisible(false)}
                visible={importVisible}
                title={"Sales Quantity Discount"}
                type={'import'}
                loader={maintainPriceLoader}
                loadImportExportData={(name, type, selected, extension, exportType) => loadImportExportData(name, type, selected, extension, exportType)}
                details={maintainPriceDetails}
                loadTasks={() => dispatchFilter(dateValue, sortBy, sortOrder)}
            />
        </React.Fragment>
    )
})

export default QuantityDiscount
